import { AbstractControl } from '@angular/forms';
import {
  SfAmountFieldData,
  SfAmountInputFormField,
  SfSelectFormField,
} from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';
import { startWith } from 'rxjs';
import { SituazioneAbitativaEnum } from '../models/libero-professionista';

export class AmountDependencyField<T> extends SfAmountInputFormField<T> {
  constructor(
    formField: IFormField<T> & SfAmountFieldData,
    private parentCtrName: Extract<keyof T, string>
  ) {
    super(formField);
  }

  override setControlRef(ctrlRef: AbstractControl<any, any> | null): void {
    super.setControlRef(ctrlRef);
    let parentCtrl = ctrlRef?.parent?.get(this.parentCtrName);
    parentCtrl?.valueChanges.subscribe((res) => {
      if (res === SituazioneAbitativaEnum.AFFITTO) {
        this.controlRef?.enable({ onlySelf: true, emitEvent: false });
        this.controlRef?.reset();
      } else {
        this.controlRef?.disable({ onlySelf: true, emitEvent: false });
        this.controlRef?.setValue('0');
      }
    });
  }
}
